export const menu = [
  {
    label: { en: "About", vi: "Giới Thiệu" },
    type: "scroll",
    path: "/about",
    showHeader: false,
    children: [
      { label: { en: "Our Story", vi: "Về Chúng Tôi" }, path: "/about#story" },
    ],
  },

  {
    label: { en: "Services", vi: "Dịch Vụ" },
    type: "dropdown",
    path: "/services", // ✅ ADD THIS

    children: [
      {
        label: {
          en: "Business Consulting",
          vi: "Tư Vấn Doanh Nghiệp",
        },
        path: "/services/business-consulting",
      },
      {
        label: {
          en: "Investment Advisory",
          vi: "Đầu Tư Doanh Nghiệp",
        },
        path: "/services/business-investment",
      },
      {
        label: {
          en: "Property Advisory",
          vi: "Đầu Tư Bất Động Sản",
        },
        path: "/services/property-investment",
      },
      {
        label: {
          en: "Business Coaching",
          vi: "Coaching Doanh Nghiệp",
        },
        path: "/services/training-coaching",
      },
      {
        label: { en: "Leadership Development", vi: "Phát Triển Lãnh Đạo" },
        path: "/services/leadership-development",
      },
      {
        label: { en: "Coach Training", vi: "Đào Tạo Coach" },
        path: "/services/coach-training",
      },
    ],
  },

  {
    label: { en: "Events", vi: "Sự Kiện" },
    type: "dropdown",
    children: [
      {
        label: {
          en: "Business Events",
          vi: "Sự Kiện Doanh Nghiệp",
        },

        path: "/events#upcoming",
      },

      // {
      //   label: {
      //     en: "Private Sessions",
      //     vi: "Tư Vấn Riêng",
      //   },

      //   path: "/events#private",
      // },

      {
        label: {
          en: "Book Your Session",
          vi: "Đặt Lịch Tư Vấn",
        },

        path: "/events#book",
      },
    ],
  },

  // {
  //   label: { en: "Networks", vi: "Kết Nối" },
  //   type: "dropdown",
  //   path: "/networks", // ✅ ADD THIS

  //   children: [
  //     {
  //       label: { en: "BDI Business Network", vi: "Mạng Lưới BDI" },
  //       path: "/networks#bdi",
  //     },
  //     {
  //       label: { en: "VBON Business Owners", vi: "Chủ Doanh Nghiệp VBON" },
  //       path: "/networks#vbon",
  //     },
  //     {
  //       label: { en: "VBC Business Coaches", vi: "Coach Doanh Nghiệp VBC" },
  //       path: "/networks#vbc",
  //     },
  //   ],
  // },

  {
    key: "insights",

    label: { en: "Insights", vi: "Phân Tích" },
    type: "dropdown",
    children: [
      {
        label: {
          en: "Government & SME Insights",
          vi: "Thông Tin Chính Phủ & Doanh Nghiệp ",
        },
        path: "/insights#government",
      },
      {
        label: {
          en: "Training & Coaching Industry ",
          vi: "Hiệp Hội Đào Tạo & Coaching",
        },
        path: "/insights#training",
      },
      {
        label: {
          en: "Market Research & Trend Platforms",
          vi: "Nghiên Cứu Thị Trường & Xu Hướng",
        },
        path: "/insights#market",
      },
    ],
  },

  {
    key: "clients&partners",

    label: {
      en: "Community",
      vi: "cộng đồng",
    },

    type: "dropdown",

    children: [
      {
        label: {
          en: "Success Stories",
          vi: "Câu Chuyện Thành Công",
        },

        path: "/community#successstories",
      },
      {
        label: {
          en: "Our Clients",
          vi: "Khách Hàng",
        },

        path: "/community#ourclient",
      },
      {
        label: {
          en: "Networks",
          vi: "Mạng lưới",
        },

        path: "/community#networks",
      },

      {
        label: {
          en: "Our Partners",
          vi: "Đối Tác",
        },

        path: "/community#ourpartners",
      },
    ],
  },

  {
    label: { en: "Contact", vi: "Liên Hệ" },
    type: "scroll",
    path: "/contact",
    children: [
      // {
      //   label: { en: "Book a Consultation", vi: "Đặt Lịch Tư Vấn" },
      //   path: "/contact#booking",
      // },
      {
        label: { en: "Send an Enquiry", vi: "Gửi Yêu Cầu" },
        path: "/contact",
      },
    ],
  },
];
